var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNursePresence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3797",
    "data-name": "Group 3797",
    transform: "translate(-427)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(427)",
    fill: "#19838c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nurse",
    transform: "translate(429.947 2.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3516",
    "data-name": "Path 3516",
    d: "M0,0V12.105H12.105V0ZM7.465,2.219l-.2.555H4.893L4.64,2.219l-.252-.706H7.717ZM4.54,8.07H5.548V7.062H6.557V8.07H7.566V9.079H6.557v1.009H5.548V9.079H4.54Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3517",
    "data-name": "Path 3517",
    d: "M8.531,11.8C7.371,11.8,5,12.405,5,13.565v3.379h7.062v-3.43C12.062,12.355,9.691,11.8,8.531,11.8Zm1.513,3.127H9.035v1.009H8.026V14.927H7.018V13.918H8.026V12.91s.757-.252,1.009,0,0,1.009,0,1.009h1.009Z",
    transform: "translate(-2.478 -5.848)",
    fill: "#fffefe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3848",
    "data-name": "Group 3848",
    transform: "translate(3.682 1.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3518",
    "data-name": "Path 3518",
    d: "M11.386,3.816h0L12.041,2H7.3l.656,1.816a1.46,1.46,0,0,0,0,.807A1.842,1.842,0,0,0,9.368,6.035a1.749,1.749,0,0,0,2.068-2.068C11.386,3.866,11.386,3.866,11.386,3.816Zm-.3-.605-.2.555H8.511l-.252-.555L8.006,2.5h3.329Z",
    transform: "translate(-7.3 -2)",
    fill: "#fffefe"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNursePresence);
export default __webpack_public_path__ + "static/media/nurse-presence.5aecf9ce0cde3c9de362e20a3961fe18.svg";
export { ForwardRef as ReactComponent };